import React, { useReducer } from 'react';
import DownlinkContext from './downlinkContext';
import DownlinkReducer from './downlinkReducer';

import clienteAxios from '../../service/axios';

import {
    OBTENER_DOWNLINK,
    DOWNLINK_ERROR,
    DOWNLINK_OK,
    ENVIAR_MENSAJE
} from 'types/context';

const DownlinkState = props => {
    const initialState = {
        downlink : null, // 
        mensaje: null
    }

    const [ state, dispatch ] = useReducer(DownlinkReducer, initialState);

    // Obtener los downlink
    const obtenerDownlink = async (dispositivo) => {
        try {
            let urlDownlink = "/downlinks";
            let resultado;
            if(dispositivo){
                urlDownlink +=`?dispositivo=${dispositivo}`
                resultado = await clienteAxios.get(urlDownlink);
            }else{
                resultado = await clienteAxios.get(urlDownlink);
            }
            dispatch({
                type: OBTENER_DOWNLINK,
                payload: resultado
            });
            return resultado;            
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }            
            dispatch({
                type: DOWNLINK_ERROR,
                payload: alerta
            })
        }
    }

    // Agregar nuevo grupo
    const enviarMensaje = async dispositivo => {
        try {
            const resultado = await clienteAxios.post(`/enviarMensaje/${dispositivo.id}`, dispositivo);
            // Insertar el grupo en el estado
            dispatch({
                type: ENVIAR_MENSAJE,
                payload: resultado.data
            })
            const alerta = {
                msg: "Estado cambiado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: DOWNLINK_OK,
                payload: alerta
            })
            return resultado.data
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            
            dispatch({
                type: DOWNLINK_ERROR,
                payload: alerta
            })
            return alerta
        }
    }
    // muestra un error de validacion
    const errorDownlink = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: DOWNLINK_ERROR,
            payload: alerta
        })
    }
    const OkDownlink = (msj,categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        }            
        dispatch({
            type: DOWNLINK_OK,
            payload: alerta
        })
    }
    const clearErrorDownlink = () => {
        dispatch({
            type: DOWNLINK_ERROR,
            payload: null,
        });
        };

    const clearOkDownlink = () => {
        dispatch({
            type: DOWNLINK_OK,
            payload: null,
        });
    };

    return(
        <DownlinkContext.Provider
            value={{
                downlink: state.downlink,
                mensaje: state.mensaje,
                obtenerDownlink,
                errorDownlink,
                OkDownlink,
                clearErrorDownlink,
                clearOkDownlink,
                enviarMensaje
            }}
        >
            {props.children}
        </DownlinkContext.Provider>
    )
}
export default DownlinkState;
